import $ from "jquery";
import state from "../../../core/offsetState";
import axios from "axios";
import {URGENT_NEWS_SEEN} from 'Core/links';

export const clickUrgentNews = () => {
    $(document).on('click', '.urgent-news a', function (event) {
        event.preventDefault();

        const url = $(this).attr('href');

        setTimeout(function () {
            $('.urgent-news').slideUp();
            $('.urgent-news-spacer').slideUp();
            state.changeUrgentNewsHeight(0);
        }, 2000);

        axios.post(URGENT_NEWS_SEEN, {
            news_id: $(this).attr('data-news-id')
        })
            .then(() => {
                if (url.length === 0)
                    return;

                if ($(this).attr('target') === '_blank') {
                    window.open(url);

                    return;
                }

                window.location.href = url;
            });
    });
};
